export default function () {
  return new Date().getMonth() + 1;
}
